import { useCallback, useMemo, useState } from 'react';
import { OPEN_ATTACHMENT_FILE_MANAGER } from 'crm-events-data';
import { DrawerTypes } from 'FileManagerLib/Constants';
// @ts-expect-error Could not find a declaration file
import SharedDragDropContext from 'customer-data-ui-utilities/dnd/SharedDragDropContext';
import { AsyncFileManager } from 'crm-events-components/internal/fileManager/AsyncFileManager';
import httpClient from 'hub-http/clients/apiClient';
// @ts-expect-error Could not find a declaration file
import { dispatch } from 'crm_data/flux/dispatch';
// @ts-expect-error Could not find a declaration file
import { FILE_ATTACHMENT_SELECTED } from 'crm_data/actions/ActionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const useAttachmentFileManagerActionHandler = ({
  auth
}) => {
  const [shouldShowFileManager, setShouldShowFileManager] = useState(false);
  const handleAttachmentFileManagerAction = useCallback(actionType => {
    if (actionType === OPEN_ATTACHMENT_FILE_MANAGER) {
      setShouldShowFileManager(true);
      return;
    }
  }, [setShouldShowFileManager]);
  const handleAttachmentSelected = useCallback(fileData => {
    dispatch(FILE_ATTACHMENT_SELECTED, fileData);
    setShouldShowFileManager(false);
  }, [setShouldShowFileManager]);
  const handleCloseFileManager = useCallback(() => {
    setShouldShowFileManager(false);
  }, [setShouldShowFileManager]);
  const attachmentFileManager = useMemo(() => {
    if (!shouldShowFileManager) {
      return null;
    }
    return /*#__PURE__*/_jsx(AsyncFileManager, {
      auth: auth,
      httpClient: httpClient,
      SharedDragDropContext: SharedDragDropContext,
      type: DrawerTypes.FILE,
      onClose: handleCloseFileManager,
      onSelect: handleAttachmentSelected
    });
  }, [auth, handleCloseFileManager, handleAttachmentSelected, shouldShowFileManager]);
  return {
    handleAttachmentFileManagerAction,
    attachmentFileManager
  };
};